<template>
  <v-card elevation="1">
    <v-card-title class="d-block text-no-wrap text-truncate pt-2 pb-1">
      <slot
        name="title"
        :title="title"
      >
        {{ title }}
      </slot>
      <v-divider color="lightgrey" />
    </v-card-title>
    <div class="d-flex pb-2">
      <v-icon 
        v-if="icon"
        class="black--text pr-4 pl-2"
      >
        {{ icon }}
      </v-icon>
      <slot />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DataCard',
  props: {
    icon: String,
    title: String,
  },
  data () {
    return {}
  }
}
</script>